export enum ModificationModeEnum {
  ADD,
  EDIT
}
